import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export type ExpertiseIconProps = SvgIconProps

export function ExpertiseIcon(props: ExpertiseIconProps) {
  const { htmlColor } = props
  return (
    <SvgIcon width="200" height="200" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Teleexpertise">
        <g>
          <g id="XMLID_00000165231045417712105280000015658168680683626116_">
            <g>
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M184.532,55.718v37.73c0,1.84-1.5,3.34-3.33,3.34h-57.91l9.53-9.53
					c0.41-0.42,0.65-0.99,0.65-1.57v-29.97c0-1.84,1.49-3.33,3.33-3.33h44.4C183.032,52.388,184.532,53.878,184.532,55.718z"
              />
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M39.892,174.087c-8.71-4.05-16.96-9.41-24.42-16.1c1.46-23.73,19.11-43.09,42.07-47.11
					c0.04,0,0.07-0.02,0.11-0.02l0.4-0.1c6.26,5.59,14.52,9.03,23.58,9.03c9.05,0,17.31-3.44,23.57-9.03l0.14-0.01
					c0.24,0.02,0.46,0.07,0.71,0.11c0.04,0,0.06,0.02,0.11,0.02c22.96,4.02,40.6,23.38,42.07,47.11
					c-7.47,6.68-15.71,12.05-24.42,16.09v0.01c-13.27,6.17-27.63,9.28-41.96,9.28C67.532,183.368,53.172,180.268,39.892,174.087z"
              />
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M89.042,43.298c-2.75,2.05-6.34,4.37-10.76,6.46c-1.38,0.65-2.84,1.29-4.39,1.88
					c-8.3,3.21-15.69,4.07-20.72,4.26c-1.02,1.53-2.04,3.05-3.07,4.58c-0.41-0.78-1.29-2.48-2.07-4.87
					c-1.34-4.06-2.42-10.1-0.57-16.89c0.36-1.32,2.54-8.92,9.51-14.66c8.86-7.29,20.35-7.39,24.88-7.42c0.21,0,0.37,0,0.45,0
					c19.64,0,29.37,8.73,33.94,22.08c1.9,5.55,1.74,11.57-0.28,16.98c-0.61,1.66-1.4,3.27-2.36,4.78c-3.18-1.2-7.1-3.04-11.22-5.87
					c-5.91-4.09-9.9-8.65-12.39-12.03C89.692,42.808,89.372,43.048,89.042,43.298z"
              />
            </g>
            <g>
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M115.532,73.607c0.56-2.85,4.26-1.75,5.87-8.45c2.36-9.82-2.43-11.32-5.2-9.37"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M48.172,73.607c-0.56-2.85-4.26-1.75-5.87-8.45c-2.36-9.82,2.42-11.32,5.2-9.37"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M48.032,55.608c-1.34-4.06-2.42-10.1-0.57-16.89c0.36-1.32,2.54-8.92,9.51-14.66c8.86-7.29,20.35-7.39,24.88-7.42
					c0.21,0,0.37,0,0.45,0c19.64,0,29.37,8.73,33.94,22.08c1.9,5.55,1.74,11.57-0.28,16.98c-0.61,1.66-1.4,3.27-2.36,4.78
					c-3.18-1.2-7.1-3.04-11.22-5.87c-5.91-4.09-9.9-8.65-12.39-12.03c-0.3,0.23-0.62,0.47-0.95,0.72
					c-2.75,2.05-6.34,4.37-10.76,6.46c-1.38,0.65-2.84,1.29-4.39,1.88c-8.3,3.21-15.69,4.07-20.72,4.26
					c-1.02,1.53-2.04,3.05-3.07,4.58C49.692,59.698,48.812,57.998,48.032,55.608z"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M48.172,73.607c3.13,20.82,16.89,36.5,33.4,36.5c0.09,0,0.19,0,0.28,0c0.09,0,0.18,0,0.28,0c16.51,0,30.27-15.68,33.4-36.5"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M123.812,174.087c-13.27,6.17-27.63,9.28-41.96,9.28c-14.32,0-28.68-3.1-41.96-9.28c-8.71-4.05-16.96-9.41-24.42-16.1
					c1.46-23.73,19.11-43.09,42.07-47.11c0.04,0,0.07-0.02,0.11-0.02"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M105.342,110.747c0.24,0.02,0.46,0.07,0.71,0.11c0.04,0,0.06,0.02,0.11,0.02c22.96,4.02,40.6,23.38,42.07,47.11
					c-7.47,6.68-15.71,12.05-24.42,16.09"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="92.952"
                y1="70.147"
                x2="96.412"
                y2="70.147"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="66.852"
                y1="70.147"
                x2="70.752"
                y2="70.147"
              />

              <polyline
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                points="
					123.812,174.087 123.812,174.077 123.812,156.447 				"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="39.892"
                y1="174.087"
                x2="39.892"
                y2="156.447"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M58.052,110.757c6.26,5.59,14.52,9.03,23.58,9.03"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M105.202,110.757c-6.26,5.59-14.52,9.03-23.57,9.03"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M132.822,87.257c0.41-0.42,0.65-0.99,0.65-1.57v-29.97c0-1.84,1.49-3.33,3.33-3.33h44.4c1.83,0,3.33,1.49,3.33,3.33v37.73
					c0,1.84-1.5,3.34-3.33,3.34h-57.91L132.822,87.257z"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M77.962,49.888c0.1-0.04,0.21-0.09,0.32-0.13c2.83-1.16,6.74-3.13,10.76-6.46c0.19-0.16,0.39-0.32,0.58-0.49
					c4.36-3.74,7.11-7.65,8.74-10.41"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M74.122,79.028h-15.62c-1.81,0-3.29-1.48-3.29-3.29v-8.97c0-1.8,1.48-3.28,3.29-3.28h15.62c1.81,0,3.29,1.48,3.29,3.28v8.97
					C77.412,77.548,75.932,79.028,74.122,79.028z"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M105.202,79.028h-15.62c-1.81,0-3.29-1.48-3.29-3.29v-8.97c0-1.8,1.48-3.28,3.29-3.28h15.62c1.81,0,3.29,1.48,3.29,3.28v8.97
					C108.492,77.548,107.012,79.028,105.202,79.028z"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M77.592,70.327c0.1-0.16,1.47-2.32,4.07-2.4c1.88-0.06,3.64,0.98,4.54,2.68"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="65.422"
                y1="43.647"
                x2="53.172"
                y2="55.897"
              />

              <polyline
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                points="
					108.492,130.697 108.492,138.878 108.492,147.057 				"
              />

              <polyline
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                points="
					116.672,138.878 108.492,138.878 100.312,138.878 				"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="145.622"
                y1="64.327"
                x2="172.202"
                y2="64.327"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="145.622"
                y1="74.588"
                x2="172.202"
                y2="74.588"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="145.622"
                y1="84.838"
                x2="162.202"
                y2="84.838"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M73.202,94.128c2.69,2.05,5.65,3.21,8.7,3.21c3.04,0,6-1.16,8.69-3.21"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Layer_1"></g>
    </SvgIcon>
  )
}

export default ExpertiseIcon
